import React from "react";
import styles from "./ExtraInformation.module.css";
import "../constants/constants.css";

const ExtraInformation = ({ index, indexAdPosition, register }) => {
  return (
    <article className={styles["textarea-container"]}>
      <label>Extra Information</label>
      <textarea
        className={styles["input-block"]}
        placeholder="<p>This template is used only on web. Please request the paralax scroller for inApp.</p><p>The size may vary depending on the website. These exceptions to the default size (100x100%) can be checked, next to all the possibilities of the Interscroller, at the following help center page: <a style='color:#4183c4;text-decoration: none;' target='_blank' href='https://support.weborama.nl/hc/en-us/articles/115001467332-Interscroller-Format'>Interscroller</a>.</p>"
        name={`creatives[${index}].adPositions[${indexAdPosition}].extraInformation`}
        {...register(
          `creatives[${index}].adPositions[${indexAdPosition}].extraInformation`,
          {
            required: false,
          }
        )}
      />
      <p className="message">
        Please insert HTML here including styling if needed. This information is
        the same for all positions inside a creative. Only use single quotes
        because it won't be accepted inside a JSON structure!
      </p>
    </article>
  );
};

export default ExtraInformation;
